import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import Grid from '@material-ui/core/Grid';

import { AppConfig } from '../../AppConfig';
import { CommonStyles } from '../../styles/Styles';
import Icon from '@material-ui/core/Icon';
import { Button } from '@material-ui/core';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { withStyles } from '@material-ui/core/styles';
import { AppTheme } from '../../styles/AppTheme';

const CustomTableCell = withStyles(theme => ({
  head: {
    fontSize: 13,
    color: '#7E8691',
    fontWeight: 600,
  },
  body: {
    fontSize: 14,
    fontWeight: 600,
  },
}))(TableCell);

export class TableData extends Component {
  constructor(props) {
    super(props);
    this.state = {
    }
  }

  render() {
    return (
      <div className={css(Styles.outerContainer)}>
        <div className={css(Styles.headerContainer)}>
          <div className={css(Styles.headerInnerContainer)}>
            <Icon className={css(Styles.orgIcon)}>{this.props.titleIcon}</Icon>
            <p className={css(Styles.headerTitle)}>{this.props.titleText}</p>
          </div>
          <div className={css(Styles.addButton)}>
            <Fab color='primary'
              onClick={() => this.props.addFunction()}
              classes={{
                root: css(Styles.addIconRoot),
                primary: css(Styles.addIcon)
              }}
            >
              <AddIcon />
            </Fab>
          </div>
        </div>
        <div className={css(Styles.tableOuterContainer)}>
          <Table className={css(Styles.tableInnerContainer)} fixedHeader={false} style={{ tableLayout: 'auto' }}>
            <TableHead>
              <TableRow className={css(Styles.tableHeader)}>
                {this.props.columnTitle.map(data => {
                  return (
                    <CustomTableCell align='left'>{data}</CustomTableCell>
                  )
                })}
                <CustomTableCell></CustomTableCell>
              </TableRow>
            </TableHead>
            {this.props.tableData !== undefined &&
            <TableBody>
              {this.props.tableData.map(row => {
                return (
                  <TableRow className={css(Styles.customeRow)}>
                    <CustomTableCell component='th' scope='row' >
                      {row._id}
                    </CustomTableCell>
                    <CustomTableCell align='left'>
                      {row.email ? row.email : row.name}
                    </CustomTableCell>
                    <CustomTableCell align='right'>
                      {this.props.icons.map(icon => {
                        return (
                          <Icon className={css(Styles.icons)} color='secondary'
                            onClick={() => this.props[icon.funcName](row)}>
                            {icon.title}
                          </Icon>
                        )
                      })}
                    </CustomTableCell>
                  </TableRow>
                );
              })}
            </TableBody>
            }
          </Table>
        </div>
      </div>
    )
  }
}

const Styles = StyleSheet.create({
  outerContainer: {
    width: '100%',
    minHeight: 430,
    overflow: 'hidden',
    marginBottom: 30,
    boxShadow: '0 0 5px 1px rgba(16, 17, 17, 0.4)',
  },
  headerContainer: {
    backgroundColor:AppTheme.secondaryBg,
    padding: 15,
    display: 'flex',
    borderBottom: '2px solid #303E8A'
  },
  headerInnerContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  orgIcon: {
    color: '#FF4081',
    fontSize: 40,
  },
  headerTitle: {
    fontSize: 25,
    margin: 0,
    fontWeight: 'bolder',
    marginLeft: 10
  },
  addButton: {
    display: 'flex',
    flex: 1,
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
  },
  addIconRoot: {
    width: 40,
    height: 40,
  },
  addIcon: {
    color: 'white',
    backgroundColor: '#FF4081'
  },
  tableOuterContainer: {
    display: 'flex',
    flex: '1 1 100%'
  },
  tableInnerContainer: {
    width: '100%',
  },
  icons: {
    marginLeft: 10,
    cursor: 'pointer'
  }
})



// WEBPACK FOOTER //
// ./src/common/components/TableData.js